module.exports = __webpack_public_path__ + "img/optim.fe4bdd7b.png";